module.exports = __webpack_public_path__ + "img/reset-password.6c09f0fb.png";